// @ts-ignore
import Vue3Lottie from "vue3-lottie"
import "vue3-lottie/dist/style.css"

export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.use(Vue3Lottie, { name: "LottieAnimation" })
})

declare module "@vue/runtime-core" {
	export interface GlobalComponents {
		// @ts-ignore
		LottieAnimation: typeof import("vue3-lottie")["Vue3Lottie"]
	}
}
